export enum ExecutionStatus {
    Waiting = 'waiting',
    Processing = 'processing',
    Completed = 'completed',
    Failed = 'failed',
    Scheduled = 'scheduled',
}